import { render, staticRenderFns } from "./DashboardFranchiseeProfile.vue?vue&type=template&id=50cb152a&scoped=true&"
import script from "./DashboardFranchiseeProfile.vue?vue&type=script&lang=js&"
export * from "./DashboardFranchiseeProfile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFranchiseeProfile.vue?vue&type=style&index=0&id=50cb152a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb152a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
